/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'transfer': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M159.858 739.556L307.54 905.102a60.245 60.245 0 0 1-2.389 82.717 53.703 53.703 0 0 1-78.108-2.276L24.633 758.556A60.075 60.075 0 0 1 9.5 714.183a56.889 56.889 0 0 1 47.389-88.405l910.222-.057a56.889 56.889 0 0 1 0 113.778H159.858zm682.666-455.112L707.3 132.78a60.245 60.245 0 0 1 2.332-82.66 53.703 53.703 0 0 1 78.108 2.219l202.468 226.986a62.27 62.27 0 0 1 10.183 15.872 56.832 56.832 0 0 1-33.28 103.026H56.89a56.889 56.889 0 1 1 0-113.778h785.635z" _fill="#7F8A99"/>'
  }
})
